/**
 * Utilidades de filtros de resúmenes de cuenta (V3).
 * Réplica la lógica de `web/src/pages/accounts/Extract.jsx` (legacy) sin modificar ese flujo.
 */
import moment from "moment";

import * as i18n from "util/i18n";

const EXTRACT_YEAR_BASE = 2021;

/** Años disponibles: año actual hacia atrás hasta 2021 (igual que legacy). */
export function buildExtractYearOptions(date = new Date()) {
    const currentYear = moment(date).year();
    return Array.from({ length: currentYear - EXTRACT_YEAR_BASE + 1 }, (_, idx) => {
        const year = currentYear - idx;
        return { value: String(year), label: String(year) };
    });
}

/**
 * Meses disponibles según año seleccionado (igual que legacy `Extract.jsx`):
 * - Año anterior al actual: todos los meses.
 * - Año actual: hasta el mes en curso (inclusive).
 */
export function buildExtractMonthOptions(searchYear, date = new Date()) {
    const currentYear = moment(date).year();
    const year = Number(searchYear);
    const monthsArray = i18n.getArray("global.months").map((label, idx) => ({
        value: idx < 9 ? `0${idx + 1}` : `${idx + 1}`,
        label: label.toUpperCase(),
    }));

    return monthsArray
        .sort((a, b) => (a.value < b.value ? 1 : -1))
        .filter((month) => parseInt(month.value, 10) <= date.getMonth() + 1 || year < currentYear);
}

/** Año inicial del filtro: año en curso (igual que legacy `mapPropsToValues`). */
export function getExtractDefaultYear(date = new Date()) {
    return moment(date).year();
}
